export const zh = {
    pagination:{
        goto:'前往',
        pagesize:'条/页',
        total:'共{total}条',
        pageClassifier:'页'
    },
    select:{
        placeholder: '请选择',
        noData: "无数据",
    },
    datepicker:{
        cancel: '取消',
        clear: '清除',
        confirm: '确定',
        startDate: '开始日期',
        startTime: '开始时间',
        endDate: '结束日期',
        endTime: '结束时间',
        year: '年',
        month1: '1月',
        month2: '2月',
        month3: '3月',
        month4: '4月',
        month5: '5月',
        month6: '6月',
        month7: '7月',
        month8: '8月',
        month9: '9月',
        month10: '10月',
        month11: '11月',
        month12: '12月',
        months:{

        },
        prevYear: '上一年',
        weeks:{
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六',
        }
    },
    table:{
        emptyText: '暂无数据',
    },
    messagebox:{
        confirm: '确定',
    },
    upload: {
        deleteTip: '删除'
    },
    cascader: {
        noData: '暂无数据',
        placeholder : '请选择',
    },
    transfer: {
        noData: '暂无数据',
        filterPlaceholder: '请输入搜索内容',
    }
}

export const en = {
    pagination:{
        goto:'goto',
        pagesize:'/page',
        total:'total {total} strip',
        pageClassifier:'page'
    },
    select:{
        placeholder: 'Please select',
        noData: "No data",
    },
    datepicker:{
        cancel: 'cancel',
        clear: 'clear',
        confirm: 'confirm',
        startDate: 'Start date',
        startTime: 'Start time',
        endDate: 'End date',
        endTime: 'End time',
        year: 'Year',
        month1: 'Jan.',
        month2: 'Feb.',
        month3: 'Mar.',
        month4: 'Apr.',
        month5: 'May.',
        month6: 'Jun.',
        month7: 'Jul.',
        month8: 'Aug.',
        month9: 'Sep.',
        month10: 'Oct.',
        month11: 'Nov.',
        month12: 'Dec.',
        months:{

        },
        prevYear: '上一年',
        weeks:{
            sun: 'Sun.',
            mon: 'Mon.',
            tue: 'Tues.',
            wed: 'Wed.',
            thu: 'Thur.',
            fri: 'Fri.',
            sat: 'Sat.',
        }
    },
    table:{
        emptyText: 'No data',
    },
    messagebox:{
        confirm: 'Confirm',
    },
    upload: {
        deleteTip :'delete'
    },
    cascader: {
        noData: 'No data',
        placeholder : 'Please select',
    },
    transfer: {
        noData: 'No data',
        filterPlaceholder: 'Please enter the search content',
    }
}
